document.addEventListener('DOMContentLoaded', function () {
  let prevActiveIndex = 0;
  const curveSwiper = new Swiper('.curve-slider', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1,
    spaceBetween: 60,
    // grabCursor: true,
    allowTouchMove: false,
    centeredSlides: true,
    // centeredSlidesBounds: true,
    // centerInsufficientSlides: true,
    parallax: true,
    speed: 800,
    on: {
      init: function () {
        prevActiveIndex = this.activeIndex;
      },
      slideChangeTransitionStart: function () {},
      slideChangeTransitionEnd: function () {
        const headings = document.querySelectorAll('.curve-slider .slide-heading');
        const highlights = document.querySelectorAll('.curve-slider .slide-highlight');

        setTimeout(() => {
          headings.forEach((heading) => {
            heading.classList.remove('inward', 'outward');
          });
          highlights.forEach((highlight) => {
            highlight.classList.remove('inward', 'outward');
          });
        }, 200);

        setTimeout(() => {
          const images = document.querySelectorAll('.curve-slide-image');
          // let allSlides = document.querySelectorAll(".curve-slider .swiper-slide");
          images.forEach((img) => {
            img.classList.remove('inward', 'outward');
          });
          // allSlides.forEach(img => {
          //   img.classList.remove('inward', 'outward');
          // });
        }, 100);
      },
    },
    breakpoints: {
      900: {
        slidesPerView: 'auto',
        spaceBetween: 120,
        centeredSlides: true,
      },
    },
  });
  function setClipPath(direction) {
    const headings = document.querySelectorAll('.curve-slider .slide-heading');
    const highlights = document.querySelectorAll('.curve-slider .slide-highlight');
    const images = document.querySelectorAll('.curve-slide-image');

    headings.forEach((heading) => {
      heading.classList.add(direction);
    });
    highlights.forEach((highlight) => {
      highlight.classList.add(direction);
    });
    images.forEach((img) => {
      img.classList.remove('inward', 'outward');
      img.classList.add(direction);
    });
  }

  document
    .querySelector('.curve-sliding .swiper-button-next')
    .addEventListener('click', function () {
      setClipPath('outward');
    });

  document
    .querySelector('.curve-sliding .swiper-button-prev')
    .addEventListener('click', function () {
      setClipPath('inward');
    });

  // curveSwiper.on('slideChange', function (swiper) {
  //   if (swiper.touches.diff < 0) {
  //     setClipPath('inward');
  //   } else {
  //     setClipPath('outward');
  //   }
  // });
});
